import { C, DEP_ZONES, IMPACTO_OPTS, RESPALDO_OPTS, depZoneForScore } from "./constants";

const IMP = { alto: 2, medio: 1, bajo: 0 };
const RES = { nadie: 2, una: 1, varias: 0 };

const ZoneTag = ({ zona }) => (
  <span className="inline-block rounded-md px-2 py-0.5 text-[11px] font-bold" style={{ background: DEP_ZONES[zona].bg, color: DEP_ZONES[zona].fg }}>{zona}</span>
);

const Grid = ({ rows }) => (
  <div className="hidden md:grid gap-2" style={{ gridTemplateColumns: "120px repeat(3, minmax(0, 1fr))" }} data-testid="tablero-dep-grid">
    <div />
    {RESPALDO_OPTS.map((r) => <div key={r.v} className="text-[12px] font-bold text-center pb-1" style={{ color: C.text }}>{r.l}</div>)}
    {IMPACTO_OPTS.map((imp) => [
      <div key={`l-${imp.v}`} className="text-[12px] font-bold flex items-center" style={{ color: C.text }}>Impacto {imp.l.toLowerCase()}</div>,
      ...RESPALDO_OPTS.map((res) => {
        const zona = depZoneForScore(IMP[imp.v] + RES[res.v]);
        const items = rows.filter((f) => f.impacto === imp.v && f.respaldo === res.v);
        return (
          <div key={`${imp.v}-${res.v}`} className="rounded-lg p-2.5 min-h-[88px] flex flex-col gap-1.5" style={{ background: DEP_ZONES[zona].bg }}>
            <span className="text-[10px] font-bold uppercase tracking-[0.14em]" style={{ color: DEP_ZONES[zona].fg }}>{zona}</span>
            {items.map((f) => (
              <span key={f.orden} className="rounded-md bg-white px-2 py-1 text-[12px] font-semibold border" style={{ color: C.text, borderColor: "rgba(14,31,25,0.15)" }}>
                {f.nombre}{f.zona !== zona ? ` · ${f.zona}` : ""}
              </span>
            ))}
          </div>
        );
      }),
    ])}
  </div>
);

export const DependencyResult = ({ rows }) => (
  <div className="space-y-4" data-testid="tablero-dep-result">
    <Grid rows={rows} />
    <p className="hidden md:block text-[11px]" style={{ color: "#5B6B64" }} data-testid="tablero-dep-legend">
      La etiqueta de cada casilla supone que la función está documentada. Si no lo está, su zona real aparece junto a su nombre.
    </p>
    <div className="space-y-2">
      {rows.map((f) => (
        <div key={f.orden} className="rounded-xl bg-white border p-4" style={{ borderColor: "#E3E7E1" }} data-testid={`tablero-dep-item-${f.prioridad}`}>
          <div className="flex flex-wrap items-center gap-2 mb-1">
            <span className="text-[12px] font-bold" style={{ color: C.gold }}>#{f.prioridad}</span>
            <span className="text-[15px] font-bold" style={{ color: C.text }}>{f.nombre}</span>
            <ZoneTag zona={f.zona} />
          </div>
          <p className="text-sm" style={{ color: C.text }}>{f.texto}</p>
        </div>
      ))}
    </div>
  </div>
);
